export const toastCopyDe = {
    saved: "Gespeichert",
    savedForNow: "Vorläufig gespeichert.",
    savedSuccessfully: "Erfolgreich gespeichert",
    errorSaving: "Fehler beim Speichern",
    errorSavingTracker: "Fehler beim Speichern des Trackers",
    updateFailed: "Aktualisierung fehlgeschlagen",
    errorUpdating: "Fehler beim Aktualisieren",
    errorCreating: "Fehler beim Erstellen",
    errorCreatingInput: "Fehler beim Erstellen der Eingabe",
    errorCreatingDiaryLog: "Fehler beim Erstellen des Tagebucheintrags",
    errorCreatingEvent: "Fehler beim Erstellen des Ereignisses",
    errorUpdatingEvent: "Fehler beim Aktualisieren des Ereignisses",
    errorUpdatingProfile: "Fehler beim Aktualisieren des Profils, bitte erneut versuchen",
    errorWhileUploading: "Fehler beim Hochladen",
    refreshAndRetry: "Fehler, bitte Seite aktualisieren und erneut versuchen",
    noDataReturned: "Keine Daten zurückgegeben",
    settingsSaved: "Einstellungen gespeichert",
    copiedToClipboard: "In die Zwischenablage kopiert",
    linkCopiedToClipboard: "Link in die Zwischenablage kopiert",
    pleaseSelectFile: "Bitte wählen Sie eine Datei",
    pasteImageFromClipboard: "Fügen Sie ein Bild aus der Zwischenablage ein (Strg+V oder Cmd+V)",
    loggedOutSuccess: "Erfolgreich abgemeldet",
    loggingIn: "Anmeldung läuft",
    errorLoggingIn: "Fehler bei der Anmeldung",
    loginSuccessful: "Anmeldung erfolgreich",
    signUpSuccessful: "Registrierung erfolgreich",
    transferRequested: "Übertragung angefordert - bitte prüfen Sie Ihre E-Mail, ob sie angekommen ist.",
    organisationAdded: "Organisation hinzugefügt",
    organisationAlreadyAdded: "Organisation bereits hinzugefügt",
    deletionRequestSent: "Löschanfrage gesendet",
    userAuthenticated: "Benutzer authentifiziert",
    codeIncorrect: "Code falsch",
    codeCorrect: "Code korrekt",
    errorSigningIn: "Fehler bei der Anmeldung",
    otpFailedToSend: "Einmalpasswort konnte nicht gesendet werden",
    passwordUpdatedSuccess: "Passwort erfolgreich aktualisiert!",
    emailOrPasswordIncorrect: "E-Mail oder Passwort falsch",
    emailAlreadyRegistered:
        "Mit dieser E-Mail-Adresse besteht möglicherweise bereits ein Konto. Bitte melde dich an oder setze dein Passwort zurück.",
    phoneNumberConfirmed: "Telefonnummer bestätigt",
    errorConfirmingPhoneNumber: "Fehler bei der Telefonnummerbestätigung",
    profileUpdatedSuccess: "Profil erfolgreich aktualisiert",
    professionalDetailsSaved: "Berufliche Angaben gespeichert!",
    failedUpdateProfessionalDetails: "Berufliche Angaben konnten nicht aktualisiert werden",
    templateCreatedSuccess: "Vorlage erfolgreich erstellt!",
    templatesCreatedSuccess: (count) =>
        count === 1 ? "Vorlage erfolgreich erstellt!" : `${count} Vorlagen erfolgreich erstellt!`,
    failedCreateTemplate: "Vorlage konnte nicht erstellt werden",
    templateUpdatedSuccess: "Vorlage erfolgreich aktualisiert",
    failedUpdateTemplate: "Vorlage konnte nicht aktualisiert werden",
    templateDeletedSuccess: "Vorlage erfolgreich gelöscht",
    failedDeleteTemplate: "Vorlage konnte nicht gelöscht werden",
    templateDuplicatedSuccess: "Vorlage erfolgreich dupliziert",
    failedDuplicateTemplate: "Vorlage konnte nicht dupliziert werden",
    templateSharedSuccess: "Vorlage erfolgreich geteilt",
    errorSharingTemplate: (message) => `Fehler beim Teilen der Vorlage: ${message}`,
    analyticsViewSharedSuccess: "Ansicht erfolgreich geteilt",
    errorSharingAnalyticsView: (message) => `Fehler beim Teilen der Ansicht: ${message}`,
    analyticsViewUnsharedSuccess: "Geteilte Ansicht entfernt",
    errorUnsharingAnalyticsView: (message) => `Fehler beim Entfernen der geteilten Ansicht: ${message}`,
    trackerSaved: "Tracker gespeichert",
    entryUpdatedSuccess: "Eintrag erfolgreich aktualisiert",
    entrySaved: "Eintrag gespeichert",
    entryDeleted: "Eintrag gelöscht",
    entryTimingUpdated: "Eintragszeitpunkt aktualisiert",
    scheduleUpdated: "Zeitplan aktualisiert",
    entryRemovedFromSchedule: "Eintrag aus dem Zeitplan entfernt",
    entryAssignedToScheduleStep: "Eintrag dem Zeitschritt zugewiesen",
    stepAlreadyOccupied: "Dieser Schritt hat bereits einen Eintrag.",
    diaryUpdatedSuccess: "Tagebuch erfolgreich aktualisiert",
    diaryInputsAddedSuccess: "Tagebucheingaben erfolgreich hinzugefügt",
    diaryDiscardedSuccess: "Tagebuch erfolgreich verworfen",
    diaryReinstatedSuccess: "Tagebuch erfolgreich wiederhergestellt",
    diaryDischargedSuccess: "Tagebuch erfolgreich entlassen",
    diaryEnded: "Tagebuch beendet",
    labelCreated: "Label erstellt",
    labelUpdated: "Label aktualisiert",
    labelDeleted: "Label gelöscht",
    labelsUpdated: "Labels aktualisiert",
    tableSettingsSaved: "Tabelleneinstellungen gespeichert",
    detailsSaved: "Ihre Angaben wurden gespeichert.",
    hospitalNumberRequired: "Krankenhausnummer ist erforderlich",
    couldNotSaveHospitalNumber: "Krankenhausnummer konnte nicht gespeichert werden",
    sharedAttributesUpdated: "Gemeinsame Attribute aktualisiert",
    errorUpdatingSharedAttributes: "Fehler beim Aktualisieren der gemeinsamen Attribute",
    sharedAttributesCreated: "Gemeinsame Attribute erstellt",
    errorCreatingSharedAttributes: "Fehler beim Erstellen der gemeinsamen Attribute",
    diaryAccessSaved: "Tagebuchzugriff gespeichert",
    failedSaveDiaryAccess: "Tagebuchzugriff konnte nicht gespeichert werden",
    joinedDateGroupSuccess: "Datumsgruppe erfolgreich beigetreten",
    failedJoinDateGroup: (message) => `Beitritt zur Datumsgruppe fehlgeschlagen: ${message}`,
    questionnaireStopped: "Fragebogen gestoppt",
    errorStoppingQuestionnaire: "Fehler beim Stoppen des Fragebogens",
    consentAddedToDiary: "Einwilligung zum Tagebuch hinzugefügt",
    errorAddingConsentToDiary: "Einwilligung konnte nicht hinzugefügt werden",
    eventSaved: "Ereignis gespeichert",
    eventUpdated: "Ereignis aktualisiert",
    eventDeletedSuccess: "Ereignis erfolgreich gelöscht",
    eventTrackerLinked: "Ereignis und Tracker verknüpft",
    errorLinkingEventTracker: (message) => `Fehler beim Verknüpfen von Ereignis und Tracker. ${message}`,
    surgerySaved: "Operation gespeichert",
    errorCreatingSurgery: "Fehler beim Erstellen der Operation",
    surgeryOptionUpdated: "Operationsoption aktualisiert",
    errorUpdatingSurgeryOption: "Fehler beim Aktualisieren der Operationsoption",
    newSurgeryOptionSaved: "Neue Operationsoption gespeichert",
    consultationSaved: "Beratung gespeichert",
    errorCreatingConsultation: "Fehler beim Erstellen der Beratung",
    errorUpdatingConsultation: "Fehler beim Aktualisieren der Beratung",
    imagingRequestSaved: "Bildgebungsanfrage gespeichert",
    errorCreatingImagingRequest: "Fehler beim Erstellen der Bildgebungsanfrage",
    injectionDetailsUpdated: "Injektionsdetails aktualisiert",
    errorUpdatingInjectionDetails: "Fehler beim Aktualisieren der Injektionsdetails",
    injectionDiaryDefaultSaved: "Injektions-Tagebuchstandard gespeichert",
    errorSavingInjectionDiaryDefault: "Fehler beim Speichern des Injektions-Tagebuchstandards",
    diaryInjectionAdded: "Injektion zum Tagebuch hinzugefügt",
    errorCreatingDiaryInjection: "Fehler beim Erstellen der Tagebuchinjektion",
    injectionContentUpdated: "Injektionsinhalt aktualisiert",
    failedUpdateInjectionContent: "Injektionsinhalt konnte nicht aktualisiert werden",
    injectionContentDeleted: "Injektionsinhalt gelöscht",
    failedDeleteInjectionContent: "Injektionsinhalt konnte nicht gelöscht werden",
    publicStatusUpdated: "Öffentlich-Status aktualisiert",
    failedUpdatePublicStatus: "Öffentlich-Status konnte nicht aktualisiert werden",
    injectionLocationUpdated: "Injektionsort aktualisiert",
    failedUpdateInjectionLocation: "Injektionsort konnte nicht aktualisiert werden",
    newInjectionLocationCreated: "Neuer Injektionsort erstellt",
    failedCreateInjectionLocation: "Injektionsort konnte nicht erstellt werden",
    newInjectionContentsCreated: "Neuer Injektionsinhalt erstellt",
    failedCreateInjectionContents: "Injektionsinhalt konnte nicht erstellt werden",
    failedSaveInjectionDetails: "Injektionsdetails konnten nicht gespeichert werden",
    diaryShockwaveAdded: "Stoßwelle zum Tagebuch hinzugefügt",
    errorCreatingDiaryShockwave: "Fehler beim Erstellen der Tagebuch-Stoßwelle",
    diaryShockwaveSaved: "Tagebuch-Stoßwelle gespeichert",
    shockwaveDetailsUpdated: "Stoßwellendetails aktualisiert",
    errorUpdatingShockwaveDetails: "Fehler beim Aktualisieren der Stoßwellendetails",
    shockwaveDiaryDefaultSaved: "Stoßwellen-Tagebuchstandard gespeichert",
    errorSavingShockwaveDiaryDefault: "Fehler beim Speichern des Stoßwellen-Tagebuchstandards",
    shockwaveDetailsRemoved: "Stoßwellendetails entfernt",
    failedSaveShockwaveDetails: "Stoßwellendetails konnten nicht gespeichert werden",
    scheduleUpdatedSuccess: "Zeitplan erfolgreich aktualisiert",
    failedUpdateSchedule: "Zeitplan konnte nicht aktualisiert werden",
    scheduleDraftCreated: "Zeitplanentwurf erstellt",
    failedCreateScheduleFromDraft: "Zeitplan konnte nicht aus dem Entwurf erstellt werden",
    failedUpdatePublishStatus: "Veröffentlichungsstatus konnte nicht aktualisiert werden",
    formUpdated: "Formular aktualisiert",
    failedUpdateForm: "Formular konnte nicht aktualisiert werden",
    formDraftCreated: "Entwurfsformular erstellt",
    failedCreateFormFromDraft: "Formular konnte nicht aus dem Entwurf erstellt werden",
    pageSaved: "Seite gespeichert",
    failedSavePage: "Seite konnte nicht gespeichert werden",
    pageDeleted: "Seite gelöscht",
    failedDeletePage: "Seite konnte nicht gelöscht werden",
    questionSaved: "Frage gespeichert",
    failedSaveQuestion: "Frage konnte nicht gespeichert werden",
    questionDeleted: "Frage gelöscht",
    failedDeleteQuestion: "Frage konnte nicht gelöscht werden",
    patientAddedSuccess: "Patient erfolgreich hinzugefügt!",
    emailWordsUpdatedSuccess: "E-Mail-Text erfolgreich aktualisiert",
    failedUpdateEmailWords: "E-Mail-Text konnte nicht aktualisiert werden",
    emailSentSuccess: "E-Mail erfolgreich gesendet",
    diaryAlreadyRead: "Tagebuch bereits gelesen",
    noLastReadAction: "Keine letzte Leseaktion gefunden",
    actionComplete: (actionName) => `${actionName} abgeschlossen`,
    footLogCreatedSuccess: "Fußprotokoll erfolgreich erstellt",
    imageUploadedSuccess: "Bild erfolgreich hochgeladen",
    imageLabelCreatedSuccess: "Bildbeschriftung erfolgreich erstellt",
    qipPermissionsUpdated: "QIP-Berechtigungen erfolgreich aktualisiert",
    qipPermissionsUpdateFailed: "QIP-Berechtigungen konnten nicht aktualisiert werden",
    riskAssessmentUpdateFailed: "Risikobewertung konnte nicht aktualisiert werden",
    footCommentSubmitted: (comment) => `Sie haben folgenden Kommentar gesendet:\n${comment}`,
    qrCodeNotReady: "QR-Code nicht bereit",
    qrCodeCopiedToClipboard: "QR-Code in die Zwischenablage kopiert",
    couldNotCopyQrImage: "QR-Bild konnte nicht kopiert werden. Versuchen Sie einen Screenshot.",
    inviteSent: "Einladung gesendet",
    organisationRoleAddedSuccess: "Organisationsrolle erfolgreich hinzugefügt",
    errorAddingOrganisationRole: (message) => `Fehler beim Hinzufügen der Organisationsrolle: ${message}`,
    organisationRoleUpdatedSuccess: "Organisationsrolle erfolgreich aktualisiert",
    errorUpdatingOrganisationRole: (message) => `Fehler beim Aktualisieren der Organisationsrolle: ${message}`,
    organisationRoleDeletedSuccess: "Organisationsrolle erfolgreich gelöscht",
    errorDeletingOrganisationRole: (message) => `Fehler beim Löschen der Organisationsrolle: ${message}`,
    secretaryAddedToOrganisation: "Sekretärzuweisung hinzugefügt",
    errorAddingSecretaryToOrganisation: (message) => `Fehler beim Hinzufügen der Sekretärzuweisung: ${message}`,
    defaultSecretarySet: "Standardkontaktperson aktualisiert",
    errorSettingDefaultSecretary: (message) => `Fehler beim Festlegen der Standardkontaktperson: ${message}`,
    defaultSecretaryCleared: "Standardkontaktperson entfernt",
    errorClearingDefaultSecretary: (message) => `Fehler beim Entfernen der Standardkontaktperson: ${message}`,
    secretaryRemovedFromOrganisation: "Sekretärzuweisung entfernt",
    errorRemovingSecretaryFromOrganisation: (message) => `Fehler beim Entfernen der Sekretärzuweisung: ${message}`,
    newOrganisationSaved: "Neue Organisation gespeichert",
    organizationCreatedSuccess: "Organisation erfolgreich erstellt!",
    audiencesUpdatedSuccess: "Zielgruppen erfolgreich aktualisiert",
    errorUpdatingAudiences: "Fehler beim Aktualisieren der Zielgruppen",
    labelAccessUpdated: "Label-Zugriff aktualisiert",
    accessUpdated: "Zugriff aktualisiert",
    photoUpdatedSuccess: "Foto erfolgreich aktualisiert",
    failedUpdatePhoto: "Foto konnte nicht aktualisiert werden",
    photoDeletedSuccess: "Foto erfolgreich gelöscht",
    failedDeletePhoto: "Foto konnte nicht gelöscht werden",
    logoUpdatedSuccess: "Logo erfolgreich aktualisiert",
    failedUpdateLogo: "Logo konnte nicht aktualisiert werden",
    logoDeletedSuccess: "Logo erfolgreich gelöscht",
    failedDeleteLogo: "Logo konnte nicht gelöscht werden",
    smsDisabledInKnock: "SMS in Knock deaktiviert",
    failedUpdateKnockPreferences: "Knock-Einstellungen konnten nicht aktualisiert werden",
    magicLinkGenerated: "Magic Link erstellt",
    errorImpersonatingUser: "Fehler beim Impersonieren des Benutzers",
    fieldUpdatedSuccess: (field) => `${field} wurde erfolgreich aktualisiert.`,
    lockUnlockReasonRequired: (action) => `${action === "lock" ? "Abzeichnungs" : "Freigabe"}grund ist erforderlich`,
    lockUnlockSuccess: (action, count) => `${count} Tagebücher ${action === "lock" ? "gesperrt" : "freigegeben"}`,
    errorResolvedSuccess: "Fehler erfolgreich behoben",
    failedResolveError: (message) => `Fehler konnte nicht behoben werden: ${message}`,
    healthCheckCompleted: (message) => `Gesundheitsprüfung abgeschlossen: ${message}`,
    healthCheckFailed: (message) => `Gesundheitsprüfung fehlgeschlagen: ${message}`,
    expectedCountUpdatedSuccess: "Erwartete Anzahl erfolgreich aktualisiert",
    failedUpdateExpectedCount: (message) => `Erwartete Anzahl konnte nicht aktualisiert werden: ${message}`,
    fixedRecords: (fixed, failed) => `${fixed} Datensätze behoben${failed ? `, ${failed} fehlgeschlagen` : ""}`,
    failedFixSharedAttributes: (message) => `Gemeinsame Attribute konnten nicht behoben werden: ${message}`,
    failedAssignRole: (message) => `Rolle konnte nicht zugewiesen werden: ${message}`,
    failedLoadMessages: "Nachrichten konnten nicht geladen werden",
    loggedInSuccess: "Erfolgreich angemeldet",
    unknownLoginError: "Unbekannter Anmeldefehler",
    userDeleted: "Benutzer gelöscht",
    passwordSetSuccess: "Passwort erfolgreich festgelegt!",
    emailVerificationSent: "E-Mail-Verifizierung gesendet",
    verificationCodeSent: "Bestätigungscode gesendet",
    verificationCodeSentEmail: "Bestätigungscode an Ihre E-Mail gesendet",
    failedSendVerificationCode: "Bestätigungscode konnte nicht gesendet werden",
    emailVerificationFailed: "E-Mail-Verifizierung fehlgeschlagen",
    emailVerified: "E-Mail verifiziert",
    emailVerifiedShort: "E-Mail verifiziert!",
    invalidVerificationCode: "Ungültiger Bestätigungscode",
    emailSetSuccess: "E-Mail erfolgreich festgelegt",
    emailSavedToProfileToast: "E-Mail-Adresse in Ihrem Profil gespeichert",
    emailUpdatedSuccessToast: "E-Mail-Adresse erfolgreich aktualisiert",
    superUserStatusUpdated: "Superuser-Status aktualisiert",
    userInvited: "Benutzer eingeladen",
    profileAttributeLocked: "Profilattribut ist gesperrt",
    addressAlreadyInUse: "Diese Adresse wird bereits verwendet.",
    mustBeSignedIn: "Sie müssen angemeldet sein.",
    contactPersonRequired: "Kontaktperson ist erforderlich.",
    somethingWentWrong: "Etwas ist schiefgelaufen. Bitte erneut versuchen.",
    resultsSentToEmail: "Ergebnisse an Ihre E-Mail gesendet!",
    resultsEmailSendFailed:
        "Ihre Ergebnisse sind bereit, aber die E-Mail konnte nicht gesendet werden. Bitte versuchen Sie es später erneut.",
    fixHighlightedFieldsBeforeInvite: "Bitte korrigieren Sie die markierten Felder, bevor Sie die Einladung senden.",
    pdfDownloaded: "PDF heruntergeladen",
    pdfDownloadFailed: "PDF-Download fehlgeschlagen",
    pdfGenerationFailed: "PDF-Erstellung fehlgeschlagen",
    questionnaireResumed: "Fragebogen fortgesetzt",
    errorResumingQuestionnaire: "Fehler beim Fortsetzen des Fragebogens",
    trackerDeletedSuccess: "Tracker erfolgreich gelöscht",
    diaryCreatedSuccess: "Tagebuch erfolgreich erstellt",
    diaryDeletedSuccess: "Tagebuch erfolgreich gelöscht",
    templateSavedSuccess: "Vorlage erfolgreich gespeichert",
    failedSaveTemplate: "Vorlage konnte nicht gespeichert werden",
    diaryAccessRemoved: "Tagebuchzugriff entfernt",
    failedRemoveDiaryAccess: "Tagebuchzugriff konnte nicht entfernt werden",
    entryRemindersTriggered: "Eintragserinnerungen für Tracker ausgelöst",
    correctionSaved: "Korrektur gespeichert",
    correctionReasonRequired: "Korrekturgrund ist erforderlich",
    errorAddingPatient: "Fehler beim Hinzufügen des Patienten, bitte Seite aktualisieren und erneut versuchen.",
    invalidDate: "Ungültiges Datum",
    failedCreateDiary: (message) => `Tagebuch konnte nicht erstellt werden: ${message}`,
    failedUpdateEntry: (message) => `Eintrag konnte nicht aktualisiert werden: ${message}`,
    failedDeleteSchedule: (message) => `Zeitplan konnte nicht gelöscht werden: ${message}`,
    failedCopySchedule: (message) => `Zeitplan konnte nicht kopiert werden: ${message}`,
    errorAddingUserToOrganisation: (message) => `Fehler beim Hinzufügen des Benutzers zur Organisation: ${message}`,
    emailRequiredRefresh:
        "Wir benötigen Ihre E-Mail-Adresse. Bitte Seite aktualisieren und das Formular erneut absenden.",
    templateStillLoading: "Vorlage wird noch geladen. Bitte in einem Moment erneut versuchen.",
    phoneUpdatedSuccess: "Telefonnummer erfolgreich aktualisiert",
    failedUpdatePhone: "Telefonnummer konnte nicht aktualisiert werden. Bitte erneut versuchen.",
    completeRequiredFields: (fieldsList) => `Bitte füllen Sie die folgenden Pflichtfelder aus:\n${fieldsList}`,
    missingEntry: "Eintrag fehlt",
    formSubmissionError: (message) => `Fehler beim Absenden des Formulars: ${message}`,
    organisationDeleted: "Organisation gelöscht",
    noRowsToExport: "Keine Zeilen auf dieser Seite zum Exportieren",
    exportedChangeEventsFromPage: (count) => `${count} Änderungsereignisse von dieser Seite exportiert`,
    noChangeEventsMatchFilters: "Keine Änderungsereignisse entsprechen diesen Filtern",
    exportedChangeEvents: (count) => `${count} Änderungsereignisse exportiert`,
    mustSignInToExportSnapshot: "Sie müssen angemeldet sein, um einen Snapshot zu exportieren",
    noDiariesToExport: "Keine Tagebücher zum Exportieren - Suche oder Filter anpassen",
    chooseSnapshotDateTime: "Wählen Sie Datum und Uhrzeit für den Snapshot",
    snapshotExported: (count, dateTime) =>
        count === 1
            ? `Snapshot für 1 Tagebuch exportiert (Stand: ${dateTime} UTC)`
            : `Snapshot für ${count} Tagebücher exportiert (Stand: ${dateTime} UTC)`,
    snapshotExportFailed: "Snapshot-Export fehlgeschlagen",
    exportFailed: "Export fehlgeschlagen",
    exportedChangeEventsTruncated: (exported, total) =>
        `Erste ${exported} von ${total} passenden Änderungsereignissen exportiert (Limit: 10.000 Zeilen)`,
    printing: "Drucken",
    failedGeneratePrintUrl: "Druck-URL konnte nicht erstellt werden",
    reportPrintQueued:
        "Bericht in Warteschlange. Er wird in Kürze auf dem Server erstellt - versuchen Sie es in einigen Minuten erneut.",
    reportPrintRendering: "Bericht wird erstellt...",
    reportPrintRefreshing: "Tagebuch aktualisiert - neuer Bericht wird erstellt...",
    reportPrintPreparing: "Bericht wird vorbereitet...",
    reportPrintTimeout: "Der Bericht dauert länger als erwartet. Bitte versuchen Sie es in einigen Minuten erneut.",
    unknownError: "Unbekannter Fehler",
    failedCreateOrganisation: "Organisation konnte nicht erstellt werden",
    correctionFailed: "Korrektur fehlgeschlagen",
    couldNotSaveProcedureDate: "Eingriffsdatum konnte nicht gespeichert werden",
    couldNotSave: "Speichern fehlgeschlagen",
    invalidFieldSelection:
        "Ein oder mehrere Felder haben eine ungültige Auswahl - bitte Formular prüfen und erneut versuchen.",
    completeAllRequiredFieldsBeforeSaving: "Bitte füllen Sie alle Pflichtfelder aus, bevor Sie speichern.",
    detailsAlreadySaved: "Diese Angaben wurden bereits gespeichert.",
    unableToSaveInjectionDetails:
        "Injektionsdetails konnten nicht gespeichert werden. Bitte Eingaben prüfen und erneut versuchen.",
    unableToSaveShockwaveDetails:
        "Stoßwellendetails konnten nicht gespeichert werden. Bitte Eingaben prüfen und erneut versuchen.",
    invitationLinkExpired:
        "Dieser Einladungslink ist abgelaufen. Geben Sie Ihre E-Mail-Adresse ein, um einen neuen Code zu erhalten.",
    invitationLinkInvalid:
        "Dieser Link ist ungültig oder abgelaufen. Geben Sie Ihre E-Mail-Adresse ein, um einen neuen Code zu erhalten.",
    confirmAccountCouldNotTextTryEmail:
        "Wir konnten keine SMS an diese Nummer senden. Versuchen Sie es mit der E-Mail aus Ihrer Einladung, falls vorhanden.",
    confirmAccountNoAccountForDetails:
        "Wir konnten kein Konto mit diesen Angaben finden. Bitte prüfen Sie die Eingabe oder wenden Sie sich an das Team, das Sie eingeladen hat.",
    smsVerificationUnavailableForNumber:
        "SMS-Bestätigung ist für diese Nummer noch nicht verfügbar. Verwenden Sie die E-Mail aus Ihrer Einladung oder wenden Sie sich an das Team, das Sie eingeladen hat.",
    smsVerificationTextFailedSignup:
        "Wir konnten keinen Bestätigungstext an diese Nummer senden. Wenn Sie ein Konto haben, melden Sie sich mit Ihrer E-Mail an oder wenden Sie sich an das Team, das Sie eingeladen hat.",
    smsSignInNotEnabledForProject:
        "SMS-Anmeldung ist für dieses Projekt nicht aktiviert. Das Team, das Sie eingeladen hat, oder der Support kann helfen.",
    smsCouldNotSendCheckNumber:
        "Wir konnten keine SMS an diese Nummer senden. Prüfen Sie die Nummer, versuchen Sie die E-Mail-Anmeldung oder wenden Sie sich an das Team, das Sie eingeladen hat.",
    smsLoginTextFailedOtpDisabled:
        "Wir haben Ihr Konto gefunden, konnten aber keinen Anmelde-SMS senden. Melden Sie sich mit E-Mail und Passwort an oder wenden Sie sich an das Team, das Sie eingeladen hat.",
    smsLoginTextFailedAccountFound:
        "Wir haben Ihr Konto gefunden, konnten aber keinen Anmelde-SMS an diese Nummer senden. Melden Sie sich mit Ihrer E-Mail an oder wenden Sie sich an das Team, das Sie eingeladen hat.",
    clinicianUpdateFailedDescription: "Behandler konnte nicht aktualisiert werden. Bitte erneut versuchen.",
    lockUnlockPartialFailure: (action, succeeded, failed, failedNames, firstError) =>
        `${succeeded} Tagebücher ${action === "lock" ? "gesperrt" : "freigegeben"}, ${failed} fehlgeschlagen: ${failedNames} (${firstError})`,
    rolesAssignedToUsers: (role, assigned, failed) =>
        `${role} ${assigned} Benutzern zugewiesen${failed ? `, ${failed} fehlgeschlagen` : ""}`,
    pdfDownloadFailedDescription: "Das erstellte PDF konnte nicht heruntergeladen werden",
    pdfGenerationFailedDescription: "PDF konnte nicht erstellt werden",
    pdfDownloadSuccessDescription: "Ihr PDF wurde erfolgreich heruntergeladen.",
};
